// The one address customers are told to write to. It is a Google Workspace
// alias of info@haastia.com, which is the account the API authenticates to SMTP
// as (EMAIL_USER / EMAIL_FROM — see server/utils/sendEmail.js), so mail sent
// here and replies to our transactional mail land in the same inbox.
//
// This lived as a separate `const SUPPORT_EMAIL` in seven components plus one
// inline literal, which is why the address in the footer, the help center and
// the legal pages could drift apart without anything failing. Import it; do not
// re-declare it, and do not inline the literal.
//
// Consumers:
//   components/Footer.js                        -> site footer, every page
//   components/Pages/Contact.js                 -> the mailto the form composes
//   components/Pages/HelpCenter.js              -> "Email support" buttons
//   components/Pages/PrivacyPolicy.js           -> legal contact line
//   components/Pages/TermsAndConditions.js      -> legal contact line
//   components/customer/BookingForm.js          -> post-payment pending state
//   components/customer/ProfessionalProfile.js  -> profile-load failure state
//   pages/FeedbackSupportPage.js                -> "other ways to get help" rail
export const SUPPORT_EMAIL = "contact@haastia.com";

// The reply-time promise, as the bare duration so it reads naturally both in a
// sentence ("within {X}") and on its own in a label/value pair. It lived as four
// different hand-written phrases — "usually within one business day", "under one
// business day", "usually within a business day" and "usually the same day" —
// which is how the help centre came to contradict its own status panel. The
// feedback confirmation email repeats this literally (server cannot import from
// web); if you change it here, change server/utils/feedbackEmailTemplates.js too.
export const SUPPORT_REPLY_WINDOW = "48 hours";
